import { Injectable } from '@angular/core';
import { Language } from '@core/types/language.type';

@Injectable({
  providedIn: 'root',
})
export class DataService {
  getLanguages(): Language[] {
    // languages Castellano, Inglés
    return [
      { name: 'Español', code: 'es', flag: '/assets/icons/spain-flag.svg' },
      { name: 'English', code: 'en', flag: '/assets/icons/usa-flag.svg' },
    ];
  }

  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }
}
